import type { MobxDocument } from '../firestore-mobx'
import {
  empty,
  type FirestoreSlideDeckRubricTest,
} from '../firestore/SlideDeckRubricTest'
import type { FirebaseRepository } from './FirebaseRepository'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import { makeObservable } from 'mobx'

export class SlideDeckRubricTest extends ObservableModelWithDecorators<FirestoreSlideDeckRubricTest> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSlideDeckRubricTest>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
